var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column-reverse flex-md-column" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-5 mx-auto p-mob-0" }, [
          _c("section", { staticClass: "who-payments" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-md-6" }, [
                _c("h5", [
                  _vm._v(
                    _vm._s(
                      _vm._f("trans")("st_public.ACCEPTED PAYMENT METHODS")
                    )
                  )
                ]),
                _c("img", {
                  attrs: { src: require("assets/img/payment_methods.png") }
                })
              ]),
              _c("div", { staticClass: "col-12 col-md-6" }, [
                _c("div", { staticClass: "seperator" }),
                _c("h5", [
                  _vm._v(
                    _vm._s(_vm._f("trans")("st_public.SSL SECURE PAYMENT"))
                  )
                ]),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "29",
                        height: "35",
                        viewBox: "0 0 29 35",
                        fill: "none"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M14.96 34C14.96 34 27.96 27.4 27.96 17.5V4.3L14.96 1L1.95996 4.3V17.5C1.95996 27.4 14.96 34 14.96 34Z",
                          fill: "#60BC57",
                          "fill-opacity": "0.34"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d:
                            "M14.96 34C14.96 34 27.96 27.4 27.96 17.5V4.3L14.96 1L1.95996 4.3V17.5C1.95996 27.4 14.96 34 14.96 34Z",
                          fill: "url(#paint0_linear_9501_49619)",
                          stroke: "#60BC57",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M14.96 32.8642L15.029 32.8252C15.458 32.5852 15.938 32.2982 16.455 31.9702C17.9861 31.0027 19.4374 29.9143 20.795 28.7152C24.666 25.2772 26.96 21.4902 26.96 17.5002V5.07823L14.96 2.03223L2.95996 5.07823V17.5002C2.95996 21.4912 5.25396 25.2772 9.12396 28.7152C10.9176 30.3001 12.8738 31.6908 14.96 32.8642Z",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d: "M18.96 13L14.585 20L11.96 17.429",
                          stroke: "#61AD5A",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      }),
                      _c(
                        "defs",
                        [
                          _c(
                            "linearGradient",
                            {
                              attrs: {
                                id: "paint0_linear_9501_49619",
                                x1: "383.536",
                                y1: "491.512",
                                x2: "2464.04",
                                y2: "2028.13",
                                gradientUnits: "userSpaceOnUse"
                              }
                            },
                            [
                              _c("stop", {
                                attrs: {
                                  "stop-color": "white",
                                  "stop-opacity": "0"
                                }
                              }),
                              _c("stop", {
                                attrs: { offset: "1", "stop-color": "#F8F8F9" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c("span", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("trans")(
                            "st_public.Your information is protected by 256-bit SSL encryption."
                          )
                        )
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25c15c03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c15c03","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/WhoPayment.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-25c15c03","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/WhoPayment.vue
// module chunks = 2 3 4 5 6